export default "/images/ea0e5f38da1e5bcfb4699c9b1c10bda0.avif";